var exports = {
  "k": "x127c5a35--dc113c--container",
  "Q": "x127c5a35--dc113c--text",
};

module.exports = exports;
